import { useState, useRef, useEffect } from "react";
import { Check, X } from "@phosphor-icons/react";

/**
 * Inline editable text field for renaming history items.
 * Commits on Enter or blur; cancels on Escape.
 */
export default function InlineRename({ initialValue, onSave, onCancel }) {
  const [value, setValue] = useState(initialValue);
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const commit = () => {
    const trimmed = value.trim();
    if (trimmed && trimmed !== initialValue) onSave(trimmed);
    else onCancel();
  };

  return (
    <div className="flex items-center gap-1 flex-1 min-w-0">
      <input
        ref={inputRef}
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={e => {
          if (e.key === "Enter") { e.preventDefault(); commit(); }
          if (e.key === "Escape") onCancel();
        }}
        onBlur={commit}
        className="flex-1 min-w-0 text-sm font-medium text-slate-800 border border-primary rounded px-2 py-0.5 focus:outline-none focus:ring-1 focus:ring-primary bg-white"
        data-testid="rename-input"
      />
      <button onClick={commit} className="text-green-600 hover:text-green-700 flex-shrink-0" data-testid="rename-confirm">
        <Check size={14} weight="bold" />
      </button>
      <button onClick={onCancel} className="text-slate-400 hover:text-slate-600 flex-shrink-0" data-testid="rename-cancel">
        <X size={14} weight="bold" />
      </button>
    </div>
  );
}
